import type { I18nKey } from 'common/hooks/useTranslation';

const failedTransactionErrorCodesToI18nKey: Record<string, I18nKey> = {
  card_expired: 'cards.failedTransactionErrorCodes.cardExpired',
  card_blocked_or_cancelled:
    'cards.failedTransactionErrorCodes.cardBlockedOrCancelled',
  card_stolen: 'cards.failedTransactionErrorCodes.cardStolen',
  card_lost: 'cards.failedTransactionErrorCodes.cardLost',
  card_blocked: 'cards.failedTransactionErrorCodes.cardBlocked',
  low_budget: 'cards.failedTransactionErrorCodes.lowBudget',
  amount_limit: 'cards.failedTransactionErrorCodes.amountLimit',
  mcc_denied: 'cards.failedTransactionErrorCodes.mccDenied',
  frequency_limit: 'cards.failedTransactionErrorCodes.frequencyLimit',
  jit_not_permitted: 'cards.failedTransactionErrorCodes.jitNotPermitted',
  wallet_funds_insufficient:
    'cards.failedTransactionErrorCodes.walletFundsInsufficient',
  '3ds_not_setup': 'cards.failedTransactionErrorCodes.3dsNotSetup',
  contactless_limit_reached:
    'cards.failedTransactionErrorCodes.contactlessLimitReached',
  card_cancelled: 'cards.failedTransactionErrorCodes.cardCancelled',
  incorrect_pin_entered:
    'cards.failedTransactionErrorCodes.incorrectPinEntered',
  regulatory_amount_limit:
    'cards.failedTransactionErrorCodes.regulatoryAmountLimit',
  unknown: 'cards.failedTransactionErrorCodes.unknown',
};

export type FailedTransactionErrorCode =
  keyof typeof failedTransactionErrorCodesToI18nKey;

export const getFailedTransactionTranslationKey = (
  errorCode: FailedTransactionErrorCode,
): I18nKey => {
  return (
    failedTransactionErrorCodesToI18nKey[errorCode] ||
    'cards.failedTransactionErrorCodes.unknown'
  );
};
